import { createWebHashHistory, createRouter } from 'vue-router'

import Home from './views/HomeView.vue'
import AuthLogin from './views/auth/LoginView.vue'
import AuthReset from './views/auth/PasswordResetView.vue'
import AuthResetConfirm from './views/auth/PasswordResetConfirm.vue'

import Users from './views/users/Users.vue'

import Orders from './views/orders/Orders.vue'
import OrdersComplete from './views/orders/OrdersCompleteView.vue'
import OrdersPending from './views/orders/OrdersPendingView.vue'
import OrdersStats from './views/orders/OrdersStatsView.vue'

import TicketsHome from './views/tickets/Tickets.vue'
import TicketsOpen from './views/tickets/TicketsOpenView.vue'
import TicketsCompleted from './views/tickets/TicketsCompletedView.vue'
import TicketSingleView from './views/tickets/TicketSingleView.vue'
import TicketStats from './views/tickets/TicketStatsView.vue'

import CallsHome from './views/calls/Calls.vue'
import CallsOpen from './views/calls/CallsOpenView.vue'

import OrdersSingleView from "./views/orders/OrdersSingleView.vue";
import CallsOpenView from "./views/calls/CallsOpenView.vue";
import CallsSingleView from "./views/calls/CallsSingleView.vue";
import CallsStatsView from './views/calls/CallsStatsView.vue'
import CallsCompletedView from "./views/calls/CallsCompletedView.vue";

import ChatsHome from "./views/chat/Chat.vue"
import ChatsOpen from "./views/chat/ChatsOpen.vue";
import ChatsComplete from "./views/chat/ChatsComplete.vue";
import ChatsStats from "./views/chat/ChatsStats.vue";
import ChatView from "./views/chat/ChatView.vue";
import BulkSendsView from "./views/bulkSends/BulkSendsView.vue";
import BulkSendView from "./views/bulkSends/BulkSendView.vue";
import HomeMonitoring from "./views/monitoring/HomeMonitoring.vue";

const routes = [
    { path: '/', name: 'home', component: Home },
    { path: '/auth/login', name: 'login', component: AuthLogin },
    { path: '/auth/forgot', name: 'forgot', component: AuthReset },
    { path: '/auth/reset', name: 'reset', component: AuthResetConfirm },

    { path: '/users', name: 'users', component: Users },

    {
        path: '/orders',
        name: 'orders',
        component: Orders,
        redirect: '/orders/pending',
        children: [
            { path: '/orders/pending', name: 'orders-open', component: OrdersPending, meta: { keepAlive: true } },
            { path: '/orders/complete', name: 'orders-completed', component: OrdersComplete, meta: { keepAlive: true } },
            { path: '/orders/stats', name: 'orders-stats', component: OrdersStats },
            { path: '/orders/view/:id', name: 'orders-single', component: OrdersSingleView },
        ]
    },

    {
        path: '/tickets',
        name: 'tickets',
        component: TicketsHome,
        redirect: '/tickets/open',
        children: [
            { path: '/tickets/open', name: 'tickets-open', component: TicketsOpen, meta: { keepAlive: true } },
            { path: '/tickets/complete', name: 'tickets-completed', component: TicketsCompleted, meta: { keepAlive: true } },
            { path: '/tickets/stats', name: 'tickets-stats', component: TicketStats },
            { path: '/tickets/view/:id', name: 'tickets-single', component: TicketSingleView },
        ]
    },

    {
        path: '/calls',
        name: 'calls',
        component: CallsHome,
        redirect: '/calls/open',
        children: [
            { path: 'open', name: 'open', component: CallsOpen, meta: { keepAlive: true } },
            { path: 'stats', name: 'stats', component: CallsStatsView },
            { path: '/calls/view/:id', name: 'calls-single', component: CallsSingleView },
            { path:'/calls/complete', name: 'calls-complete', component: CallsCompletedView, meta: { keepAlive: true } },
        ]
    },

    {
        path: '/chats',
        name: 'chats',
        component: ChatsHome,
        redirect: '/chats/open',
        children: [
            { path: '/chats/open', name: 'chats-open', component: ChatsOpen, meta: { keepAlive: true } },
            { path: '/chats/complete', name: 'chats-completed', component: ChatsComplete, meta: { keepAlive: true } },
            { path: '/chats/stats', name: 'chats-stats', component: ChatsStats },
            { path: '/chats/view/:id', name: 'chats-single', component: ChatView },
            { path: '/chats/bulk-sends', name: 'bulk-sends', component: BulkSendsView, meta: { keepAlive: true } },
            { path: '/chats/bulk-sends/:uuid', name: 'bulk-sends-single', component: BulkSendView },
        ]
    },

    {
        path: '/monitoring',
        name: 'monitoring',
        component: HomeMonitoring,
        meta: { requiresMonitorToken: true }
    }
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})
 router.beforeEach((to) => {
      if (to.meta.requiresMonitorToken) {
          const token = localStorage.getItem('monitor_token')
          if (!token) {
              return { name: 'login' }
          }
      }
  })

export default router
